import React from 'react';
import { WHATSAPP_READ_ONLY_NOTICE } from '../../../../../../../../store/globalAskAica/whatsapp/constants';
import styles from './WhatsAppChat.module.scss';

/** Shown in place of the composer while a WhatsApp chat is open. */
const WhatsAppViewOnlyNotice: React.FC = () => (
    <div className={styles.Notice} data-testid="ask-aica-view-only-notice">
        {WHATSAPP_READ_ONLY_NOTICE}
    </div>
);

export default WhatsAppViewOnlyNotice;
